// extracted by mini-css-extract-plugin
export var button = "Pagination-module--button--T6iWl";
export var firstInRange = "Pagination-module--firstInRange--lCCTi";
export var item = "Pagination-module--item--+w+C5";
export var itemText = "Pagination-module--itemText--l9D+p";
export var lastInRange = "Pagination-module--lastInRange--NQDYt";
export var list = "Pagination-module--list--Ur8ic";